import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/Reports/reportsSlice";
import { useSelector } from "react-redux";
import {
  useGetOtherReportBasicDataQuery,
  useGetOtherReportDepartmentTableDataQuery,
} from "../../../../store/queries/Reports";
import { useFormik } from "formik";
import { useState } from "react";
import { subDays } from "date-fns";

const useDepartmentReport = () => {
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    key: "selection",
  });
  const startDate = new Date(date.startDate).toISOString().split("T")[0];
  const endDate = new Date(date.endDate).toISOString().split("T")[0];
  const initialFormattedDate = [startDate, endDate];
  const [formattedDate, setFormattedDate] = useState(initialFormattedDate);
  
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];

  const dispatch = useDispatch();
  const reportState = useSelector((state) => state.reports);

  const formik = useFormik({
    initialValues: {
      department: "",
      branch: "",
      order_type: {
        "id": 1,
        "name": "Fresh"
    }
    },
  });
  const { data: basicData = {} } = useGetOtherReportBasicDataQuery({});

  const {
    data: departmentData = {},
    isFetching,
    isLoading,
  } = useGetOtherReportDepartmentTableDataQuery(
    {
      date: formattedDate,
      department_id: formik?.values?.department?._id,
      per_page: reportState?.otherReport?.currentPageSize,
      page: reportState?.otherReport?.currentPage,
      sort_by: reportState?.otherReport?.sortBy,
      sort_order: reportState?.otherReport?.sortOrder,
      search: reportState?.otherReport?.search,
      branch_id: formik?.values?.branch?._id,
      order_type: formik?.values?.order_type?.id,
    },
    {
      skip: !(formik?.values?.department?._id && formik?.values?.branch && formik?.values?.order_type?.id),
    }
  );

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.search = e.target.value;
        state.otherReport.currentPage = 1;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPageSize = page_size;
        state.otherReport.currentPage = 1;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.otherReport.currentPage = page;
      })
    );
  };

  const handleSort = (label) => {
    if (reportState.otherReport.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.otherReport.currentPage = 1;
          state.otherReport.sortOrder =
            reportState.otherReport.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.otherReport.currentPage = 1;
          state.otherReport.sortBy = label;
          state.otherReport.sortOrder = "asc";
        })
      );
    }
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleDateChange = (date) => {
    const startDateUTC = new Date(date.startDate);
    const endDateUTC = new Date(date.endDate);
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
    const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);

    const formatDate = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const startDateFormatted = formatDate(startDateIST);
    const endDateFormatted = formatDate(endDateIST);
    const dateArray = [startDateFormatted, endDateFormatted];
    setFormattedDate(dateArray);
  };
  return {
    formik,
    isFetching,
    isLoading,
    reportState,
    departmentData,
    paginationOptions,
    basicData: basicData?.data,
    date,
    getRow,
    handleSort,
    handleSearch,
    handlePageSize,
    handlePagination,
    handleDateChange,
  };
};

export default useDepartmentReport;
